<template>
  <a-drawer
    :width="this.dmPlatformId?width:(width-289)"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :closable="false"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{background:'rgba(244, 249, 253, 1)',padding: 0 }"
    :drawerStyle="{background:'rgba(244, 249, 253, 1)',overflowY:'hidden'}"
    @close="handleCancel"
    cancelText="关闭">
  <a-spin :spinning="confirmLoading">
    <div class="worder-top">
      <div class="worder-title" @click="handleCancel">
        <img class="icon" src="@/assets/driver/arrow@2x.png"/>返回
      </div>
      <div class="right-btns">
        <span class="delete-order"  @click="handleCancel">
          <img class="icon" src="@/assets/driver/delete.png"/>
        </span>

      </div>
    </div>
<!--    <platform-info-table ref="platformInfoTable" v-if="dmPlatformId" :model="ptModel" ></platform-info-table>-->
    <div class="worder-content"  :style="{marginLeft:dmPlatformId?'':'24px'}">
      <platform-info ref="platformInfo" style="width: 265px" v-if="dmPlatformId" :leftMap="leftMap" @change="changeTab" @update="loadConfig" :model="ptModel"></platform-info>
      <div class="worder-info">
          <div class="worder-nav">
            <div class="worder-left">
              <span style="color:rgba(10, 22, 41, 1) " v-if="leftMap.s">{{leftMap.f?'-':''}}{{leftMap.s}}</span>
            </div>
            <div v-if="leftMap.leftTab==1"  style="margin: 14px 14px 0 0;">
              <a-button type="primary" v-if="!disableSubmit" style="margin-bottom: 0px; background: rgb(255, 0, 0); border: 1px solid rgb(255, 0, 0);height: 48px" @click="savePtInfo">保存信息</a-button>
              <a-button type="primary" @click="disableSubmit = false;"  style="height: 48px"  v-else>编辑信息</a-button>
            </div>
          </div>
          <div class="worder-summary"  v-if="leftMap.leftTab==1">
            <dm-platform-form ref="realForm" @hasChange="hasChange" :form-data="ptModel"  @ok="getInfo"  @getData="getData" @getInfo="getInfo" @close="closeTab"  :disabled="disableSubmit"></dm-platform-form>
          </div>
          <gmv-table ref="gmvTable" v-if="leftMap.leftTab==2 && dmPlatformId" :ddpId="dmPlatformId"></gmv-table>
          <platform-driver-table @view="toDriverModel" ref="platformDriverTable" v-if="leftMap.leftTab==3 && dmPlatformId" :model="ptModel"></platform-driver-table>
        </div>
      <div class="worder-sjgk">
        <div class="worder-nav">
          <div class="worder-left">
            <span style="color:rgba(10, 22, 41, 1) ">数据概况</span>
          </div>

        </div>
        <platform-info-top-new :model="ptModel" :leftTab="leftMap.leftTab"></platform-info-top-new>
      </div>
    </div>
    <view-modal-info ref="driverForm"></view-modal-info>
  </a-spin>
  </a-drawer>
</template>

<script>

  import { httpAction, getAction} from '@api/manage'
  import BackTab from "@comp/dm/BackTab.vue";
  import PlatformInfo from "@comp/dm/platform/PlatformInfo.vue";
  import DmPlatformForm from "@views/dm/dirver/windows/DmPlatformForm.vue";
  import PlatformInfoTable from "@comp/dm/platform/PlatformInfoTable.vue";
  import PlatformInfoTopNew from "@comp/dm/platform/PlatformInfoTopNew.vue";
  import GmvTable from "@comp/dm/platform/GmvTable.vue";
  import PlatformDriverTable from "@comp/dm/platform/PlatformDriverTable.vue";
  export default {
    inject:['closeCurrent'],
    name: 'DriverPlatfromInfo',
    components: {
      PlatformDriverTable,
      GmvTable,
      PlatformInfoTopNew,
      PlatformInfoTable,
      DmPlatformForm,
      PlatformInfo,
      BackTab,
      ViewModalInfo: () => import('../dm3.0/driver/DriverInfo')
    },
    data () {
      return {
        disableSubmit:true,
        width:document.documentElement.clientWidth-((document.documentElement.clientWidth-430)>1308?420:252),
        confirmLoading:true,
        dmPlatformId:null,
        visible:false,
        contentHeight:826,
        leftMap:{
          leftTab:1
        },
        dictOptions:{},
        ptModel:{

        },
        hasChangeFlag:false
      }
    },activated () {

    },created(){

    },
    methods: {
      addPlatform(driverId){
        this.leftMap = {
          leftTab:1
        }
        this.visible = true;
        this.clear();
        this.ptModel = {
          driverId:driverId
        };
        this.loadConfig()
        this.disableSubmit = false;
        this.confirmLoading = false;
      },
      edit(record){
        console.log(record)
        this.ptModel = record;
        this.hasChangeFlag = false;
        this.$nextTick(()=>{
          this.$refs.platformInfo.edit();
          if(this.leftMap.leftTab==1){
            this.hasChangeFlag = false;
            this.$refs.realForm.edit(this.ptModel);
          }
          this.$refs.platformInfoTable.init();
        })
      },
      async  showInfo(dmPlatformId){
        this.visible = true;
        this.dmPlatformId = dmPlatformId;
        this.leftMap = {
          leftTab:1
        }
        await this.loadConfig(1)
        this.confirmLoading = false;
      },clear(){
        this.ptModel = {};
        this.dmPlatformId = null;
      },changeTab(leftMap){
        if(leftMap.leftTab!=1 && this.hasChangeFlag){
          this.checkPtInfo(this.savePtInfo,null,this.changeTabSure,leftMap);
        }else{
          this.changeTabSure(leftMap)
        }
      },changeTabSure(leftMap){
        this.leftMap = leftMap;
        this.loadConfig();
      },async loadConfig(t){
        this.disableSubmit = true;
        if(t){
          this.getInfo()
        }else{
          this.getPtInfo();
        }

      },checkPtInfo(back,backParam,close,closeParam){
        this.$confirm({
          title: '提示',
          okText: '确认',
          cancelText: '取消',
          content: '信息已修改，是否保存？',
          onOk: () => {
            if(back){
              back(backParam);
            }
          },
          onCancel: () => {
            if(close){
              close(closeParam)
            }
          }
        })
      },getPtInfo(t){
        if(this.dmPlatformId && (!this.ptModel || Object.keys(this.ptModel).length==0)){
          if(!t){
            this.getInfo();
          }
        }else{
          if(this.leftMap.leftTab==1){
            this.$nextTick(()=>{
              this.$refs.realForm.edit(this.ptModel);
            })
          }
          else if(this.leftMap.leftTab==2){
            this.$nextTick(()=>{
              this.$refs.gmvTable.loadList();
            })
          }
          else{
            this.$nextTick(()=>{
              this.$refs.platformDriverTable.loadList();
            })

          }
        }
        if(t){
          this.getInfo();
        }
        this.hasChangeFlag = false;
      },handleOk(){

      },callbackOk(){
        this.loadConfig(1);
      },handleCancel(){
        if(this.leftMap.leftTab==1 && this.hasChangeFlag){
          this.checkPtInfo(this.savePtInfo,null,this.closeTab,null);
        }else{
          this.closeTab()
        }
        this.$emit("ok");
      },closeTab(){
        this.visible = false;
        this.$emit("ok")
      },
      getInfo(ptId) {
        this.visible = true;
        if(ptId){
          this.dmPlatformId = ptId
        }
        let params = {id: this.dmPlatformId};
        getAction("/dm/dmDriverPlatform/queryById", params).then((res) => {
          if (res.success) {
            if(this.ptModel.driverId){
              this.ptModel = {
                driverId:this.ptModel.driverId
              };
            }else{
              this.ptModel = {};
            }
            this.disableSubmit = true;
            this.edit(res.result);
          }
        })

      },getData(formData){
        let that = this;
        that.confirmLoading = true;
        let httpurl = '';
        let method = '';
        if(!formData.id){
          httpurl+="/dm/dmDriverPlatform/add";
          method = 'post';
        }else{
          httpurl+="/dm/dmDriverPlatform/edit";
          method = 'put';
        }
        that.loading = true
        httpAction(httpurl,formData,method).then((res)=>{
          if(res.success){
            that.$message.success("保存成功!");
            that.$emit('ok');
            that.disableSubmit = true;
            that.dmPlatformId = res.result.id;
            this.edit(res.result);
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.loading = false;
          that.confirmLoading = false;
        })

      },savePtInfo(){
        if(this.leftMap.leftTab==1){
          this.$refs.realForm.submitForm();
        }else{
          this.getData(this.ptModel);
        }

      },toDriverModel(driverId){
        this.$refs.driverForm.showInfo(null,driverId,{s:'基本信息',leftTab:1,b:'返回挂靠平台详情'})
      },hasChange(){
        this.hasChangeFlag = true;
      }
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.left-tab{
  height: 100%;
  background: rgba(244, 249, 253, 1);
}.worder-top{
   background: rgba(244, 249, 253, 1);
   display: flex;
   justify-content: space-between;
   color: rgba(56, 56, 56, 1);
   padding-left:24px;
   margin-top: 24px;
   padding-right: 4px;
 }
.worder-title{
  font-size: 24px;
  color: rgba(63, 140, 255, 1);
  cursor: pointer;
}
.worder-title .icon{
  width: 16px;
  height: 12px;
  margin-right: 6px;
  margin-top: -5px;
}
.right-btns{
  display: flex;
  align-items:center;
}

.right-btns span{
  padding: 0 10px;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
  margin-right: 20px;
  background: #fff;
  width: 44px;
  height: 44px;
  line-height: 44px;
}
.right-btns span img{
  width: 24px;
}
.right-btns span:hover{
  opacity: .8;
}

.worder-content{
  display: flex;
  margin: 24px 24px 0 0;
  gap: 24px;
  /*overflow-y: scroll;*/
  /*height: 706px;*/
}
.worder-nav{
  display: flex;
  justify-content: space-between;
}
.worder-nav .worder-left{
  font-size: 22px;
  line-height: 48px;
  margin-left: 20px;
}
.worder-f{
  cursor: pointer;
  color: rgba(63, 140, 255, 1);
}

.worder-date{
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 58px  rgba(196, 203, 214, 0.1);
  text-align: center;
  line-height: 44px;
}
.worder-date img{
  width: 24px;
  height: 24px;
}

.worder-content .worder-info{
  min-width: 600px;
  flex: 1;
}
.worder-summary{
  background: #fff;
  border-radius: 12px;
  margin-top: 24px;
}
.worder-sjgk{
  width: 265px;
  border-radius: 12px;
  background: #fff;
}
.worder-summary-top-btn{
  width: 145px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: rgba(63, 140, 255, 1);
}
.worder-nav .ant-btn{
  margin: 14px 14px 0 0 !important;
}
.worder-summary-top-btn img{
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.worder-status-btn{
  width: 145px;
  height: 48px;
  line-height: 48px;
}
.ant-drawer-open{
  transform: inherit !important;
}
/deep/ .worder-summary-top-btn .ant-select-selection--single{
  border: none !important;
  background: rgba(63, 140, 255, 1) !important;
  color: #fff;
  border-radius: 12px;
  height: 48px !important;
}
/deep/ .worder-summary-top-btn .ant-select-arrow{
  color: #fff;
}

/deep/  .iconp{padding:32px;}
/deep/ .ant-radio-button-wrapper{
  height:40px;
  line-height: 40px;
  border-radius: 8px;
}
/deep/ .ant-radio-button-wrapper:not(:first-child)::before{
  position:inherit !important;
  display:contents !important;
}
  /deep/ .ant-space-item{
    width: 100%;
  }
  /deep/ .ant-card{
    background: #f0f2f5 !important;
  }

  /*/deep/ .ant-drawer-wrapper-body{*/
    /*background: rgba(244, 249, 253, 1) !important;*/
    /*overflow-y: hidden;*/
  /*}*/
  /deep/ .ant-table-body{
    /*overflow-x:hidden !important;*/
  }
/deep/ .ant-drawer-content{
  overflow-y: hidden !important;
}

/deep/ .ant-btn {
  border: 1px solid rgba(230, 237, 245, 1) !important;
  width: 112px;
  border-radius:12px;
}
/deep/ .ant-select-selection__rendered{
  line-height: 48px !important;
}

</style>